export const baseText = {
    more:'مشاهده بیشتر',

    //داشبورد
    pocket:'کیف پول',
    lastview:'بازدیدهای اخیر',
    lastorder:'سفارشات جاری',
    cash:'وجودی',
    empty:'موردی ثبت نشده است',
    toman:'تومان',

    //منو پنل  کاربری
    dashboard:'پیشخوان',
    userdata:'اطلاعات کاربر',
    orderdata:'سفارش‌های من',
    address:'آدرس‌ها',
    message:'پیام‌ها',
    comment:'نظرات',
    likes:'علاقه‌مندی‌ها',
    affiliate:'بازاریابی',
    password:'تغییر رمز عبور',
    exit:'خروج',
    orderDitail: ' جزییات سفارش',

    //اطلاعات کاربر
    userdataTitle:'اطلاعات حساب کاربری',
    userTitle:'اطلاعات شخصی',
    userTitleedit:' ویرایش  مشخصات',
    saveEdition:'ثبت ویرایش',

    //سفارش ها
    proccess:'جاری',
    sended:'ارسال شده',
    delivered:'تحویل شده',
    canceled:'لغو شده',
    reject:'مرجوع شده',
    view:'مشاهده سفارش',
    orderInv:'شماره سفارش',
    emptyOrder:'سفارشی ثبت نشده است',

    //جزییات سفارش
    inv_number : 'کد پیگیری سفارش',
    factorView:'مشاهده فاکتور',
    countBask:'تعداد مرسوله',
    shipping:'هزینه ارسال',
    sendto:'ارسال به',
    recPhone:'شماره تماس گیرنده',
    recName:'نام تحویل گیرنده',
    history:'تاریخچه تراکنش',
    countGood:'تعدادکالا',
    shop:'فروشگاه',
    shippingdate:'تعهد ارسال',
    deliverdate:'تاریخ تحویل',
    privetkey:'کد تحویل',
    publickey:'کد تایید',
    basketcode:'کد سبد',
    situation:'وضعیت سفارش',
    orderTotal:'مبلغ سفارش',
    orderCode:'کد سفارش',
    invdate:'تاریخ ثبت سفارش',
    payMet:'توضیحات',
    trDate:'تاریخ تراکنش',
    invTotal:'مبلغ کل',
    trSituation:'وضعیت تراکنش',
    price:'مبلغ',

    //فاکتور خرید
    factor:'فاکتور خرید',
    factorTitle:'مشخصات خرید',
    buyerName:'نام خریدار',
    userAddress:'آدرس',
    userEmail:'ایمیل',
    userPost:'کد پستی',
    userphone:'شماره تماس',
    sellerName:'نام فروشنده',
    goodName:'عنوان کالا',
    goodcode:'کدسیستمی کالا',
    buycount:'تعداد',
    tax:'ارزش افزوده',
    image:'تصویر کالا',
    sum:'جمع کل(تومان)',
    shipping_cost:'هزینه ارسال(تومان)',
    off:'اعمال تخفیف(تومان)',
    sumtax:'جمع ارزش افزوده(تومان)',
    payable:'مبلغ قابل پرداخت(تومان)',
    type:'روش پرداخت',
    time:'زمان تحویل',
    newcomment:'ثبت نظر',
    rejectgood:'مرجوع کالا',
    canclegood:'لغو کالا',
    viwereject:'مشاهده مرجوعی',
    rejectalert: 'کاربر گرامی، زمان مرجوع این سفارش به پایان رسیده است',
    sheba: 'شماره شبا ی حساب خود را جهت واریز مبلغ وارد کنید',
    cancle:'انصراف',
    complite: 'تکمیل اطلاعات حقوقی ',
    question: 'آیا از لغو کالا خود مطمئن هستین؟',
    rejectReason:'دلیل مرجوعی',
    reason:'علت',
    desc:'شرح',

    //کامنت محصول 
    yes:'پیشنهاد می کنم',
    no:'پیشنهاد نمی کنم',
    idk:'نظری ندارم',
    addnewComment:'ثبت نظر جدید',
    rate:'امتیاز این  محصول از نظر شما؟',
    ycomm:'نظر شما',

    //پیام ها
    messageTitle:'پیام‌های من',
    newmsg:'ایجاد پیام',
    msg:'پیام‌ها',
    elanat:'اعلانات',
    baygani:'بایگانی',
    msgsub: 'موضوع پیام خود را انتخاب کنید',
    msgtxt:'متن پیام خود را بنویسید',
    sendmsg:'ارسال پیام',
    msgsend:'پیام شما ارسال شد',
    sendnew:'ارسال پیام جدید',
    sub:'موضوع پیام',
    attchfile:'فایل افزوده شده ',
    sender: 'ارسال از طرف',
    deletemsg: 'بایگانی پیام',
    warn:'چت توسط کارشناس مربوطه بسته شده است.',
    delAlert:'از بایگانی پیام مطمئن هستید؟',
    msgdate:'تاریخ ایجاد پیام',
    creator:'نام فرستنده',
    placeholder:'پیام خود را بنویسید...',

    //نظرات
    commtitle:'دیدگاه‌های من',
    qa:'سوال و پاسخ',
    comments:'نظرات من',
    unconfirm:'تایید نشده',
    yourq:'سوال شما',
    youra:'جواب شما',
    yes2:'خرید این محصول را پیشنهاد میکنم ',
    no2: 'خرید این محصول را پیشنهاد نمیکنم ',
    idk2: 'برای خرید این محصول نظری ندارم ',


    //کیف پول
    chargeText :'مبلغ مورد نظر خود را انتخاب کنید:',
    reciveText : 'اطلاعات حساب خود را واد کنید:',
    reciveRQ : 'موجودی حساب',

    //امتیازات
    number:'امتیازات',
    // chargeText :'مبلغ مورد نظر خود را انتخاب کنید:',
    // reciveText : 'اطلاعات حساب خود را واد کنید:',
    // reciveRQ : 'موجودی حساب'
}